import { EllipsisText, type GridColDef } from '@shared/components';
import { formatDate, formatNumber } from '@shared/utils';

import { type QSetUsageReportItem } from './types';

export const columns: GridColDef<QSetUsageReportItem>[] = [
  {
    field: 'examCourseCode',
    sortable: false,
    headerName: 'Exam Code',
    width: 120,
    align: 'center',
    headerAlign: 'center',
    renderCell: (params) => <EllipsisText>{params.row.examCourseCode}</EllipsisText>,
  },
  {
    field: 'qSetId',
    sortable: false,
    headerName: 'QSet ID',
    minWidth: 120,
    align: 'center',
    headerAlign: 'center',
    renderCell: (params) => <EllipsisText>{params.row.qSetId}</EllipsisText>,
  },
  {
    field: 'qConfigRefId',
    sortable: false,
    headerName: 'QConfig Ref.',
    width: 114,
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'startDate',
    sortable: false,
    headerName: 'Start Date',
    width: 120,
    renderCell: (params) => formatDate(params.row.startDate),
  },
  {
    field: 'endDate',
    sortable: false,
    headerName: 'End Date',
    width: 120,
    renderCell: (params) => formatDate(params.row.endDate),
  },
  {
    field: 'pValueAvg',
    sortable: false,
    headerName: 'P Avg.',
    width: 70,
    headerAlign: 'center',
    align: 'center',
    type: 'number',
    valueFormatter: (params) => params.value.toFixed(2),
  },
  {
    field: 'examineeCount',
    sortable: false,
    headerName: 'Examinee',
    width: 100,
    type: 'number',
    valueFormatter: (params) => formatNumber(params.value, 2),
  },
  {
    field: 'passedExamineeCount',
    sortable: false,
    headerName: 'Passed',
    width: 100,
    type: 'number',
    valueFormatter: (params) => formatNumber(params.value, 2),
  },
  {
    field: 'passedRate',
    sortable: false,
    headerName: 'Passing Rate (%)',
    minWidth: 144,
    type: 'number',
    valueFormatter: (params) => `${params.value.toFixed(2)}%`,
  },
  {
    field: 'maxScore',
    sortable: false,
    headerName: 'Max Score',
    width: 110,
    type: 'number',
    valueFormatter: (params) => formatNumber(params.value, 2),
  },
  {
    field: 'minScore',
    sortable: false,
    headerName: 'Min Score',
    width: 110,
    type: 'number',
    valueFormatter: (params) => formatNumber(params.value, 2),
  },
  {
    field: 'avgScore',
    sortable: false,
    headerName: 'Avg. Score',
    width: 110,
    type: 'number',
    valueFormatter: (params) => formatNumber(params.value, 2),
  },
  {
    field: 'sdScore',
    sortable: false,
    headerName: 'S.D.',
    width: 110,
    type: 'number',
    valueFormatter: (params) => formatNumber(params.value, 2),
  },
];
